// React
import React from 'react';

import { RemittanceManagement } from 'pages/remittance';
import { useUserRemittanceManagementData } from './useUserRemittanceManagementData';

export const UserRemittanceManagement: React.FC = () => {
  const {
    remittances,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    processRemittance,
    siteProviders,
  } = useUserRemittanceManagementData();
  return (
    <RemittanceManagement
      remittance={remittances}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
      processRemittance={processRemittance}
      siteProviders={siteProviders}
    />
  );
};
